var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tip_one_warp",style:('color:' +
    (_vm.status === 'success' ? 'rgb(103, 194, 58)' : 'rgb(245, 108, 108)'))},[_c('i',{class:'el-icon-' + _vm.status}),_c('span',[_vm._v(_vm._s(_vm.newErrorMsg))])])}
var staticRenderFns = []

export { render, staticRenderFns }